<div [dfs]="'p-a:2 p-t:20px flex-grow:1'">
    @switch (loadStatus.busy) {
    @case (false) {
    @if (!!config) {
    <ng-form #form="ngForm"
             [dfs]="'p-a:2 d:block'">
        @for (field of fields; track field) {
        <icms-form-field [label]="field.title">
            @if (config.data?.content) {
            <textarea [name]="field.key"
                      [(ngModel)]="config.data!.content[field.key]"
                      [placeholder]="schemaExample"
                      [required]="isRequired(field, config.data!.content)"
                      style="height: 150px"></textarea>
            }
            @if (field.description) {
            <icms-hint-banner [dfs]="'m-t:2 d:inline-block'"><span
                      [innerHTML]="field.description"></span></icms-hint-banner>
            }
        </icms-form-field>
        }
    </ng-form>
    }
    @else {
    <icms-hint-banner>Custome schema data cannot be set for current page.</icms-hint-banner>

    }
    }
    @case (true) {
    <icms-skeleton-loader [numberOfLines]="2"></icms-skeleton-loader>
    }
    }
</div>

@if (!loadStatus.busy && config) {
<div [dfs]="'p-a:2 b-t:1px bc:15'">
    <button [iCmsButtonStyle]="'accent'"
            [status]="saveStatus"
            [dfs]="'w:100%'"
            (click)="save()">Save</button>
</div>
}